export default "__VITE_ASSET__Cyjyh6hV__"